module.exports = __webpack_public_path__ + "static/media/humidity.d3917a43.svg";